import { render, staticRenderFns } from "./RbSlider.vue?vue&type=template&id=83b5252e&"
import script from "./RbSlider.vue?vue&type=script&lang=js&"
export * from "./RbSlider.vue?vue&type=script&lang=js&"
import style0 from "./RbSlider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports